import { useQuery } from "@tanstack/react-query"
import { getMyComplains } from "@/lib/api/complain.api"
import { useAuthStore } from "@/store/auth.store"

export function useGetMyComplains(enabled = true) {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["my-complains"],
    queryFn: () => getMyComplains(accessToken!),
    enabled: !!accessToken && enabled,
    staleTime:0,
  })
}
